import { useState } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import "./Register.css";
import profileHolder from "../assets/BotImage.jpg";
import { useRegisterUserMutation } from "../services/appApi";

const Register = () => {
    const navigate = useNavigate()
    //register form data states
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
    });
    const { firstName, lastName, password, email } = formData;
    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
        }));
    };
    //image upload state
    const [image, setImage] = useState(null);
    const [uploadingImage, setUploadingImage] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);

    const validateImage = (e) => {
        const file = e.target.files[0];
        if (file.size > 1048576) {
            return alert("file to large. max size is 1mb");
        } else {
            setImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    //upload profile image to cloud storage
    const uploadImage = async () => {
        const data = new FormData();
        data.append("file", image);
        data.append("upload_preset", "profilepic");
        try {
            setUploadingImage(true);
            let res = await fetch(
                "https://api.cloudinary.com/v1_1/emash/image/upload",
                {
                    method: "post",
                    body: data,
                }
            );
            const urlData = await res.json();
            setUploadingImage(false);
            return urlData.url;
        } catch (error) {
            setUploadingImage(false);
            console.log(error);
        }
    };
    //use the useRegisterUserMutation hook
    const [registerUser, { isLoading, error }] = useRegisterUserMutation();
    //register a new user
    const registerNewUser = async (e) => {
        e.preventDefault();
        if (!image) {
            return alert("please upload a profile image");
        } else {
            const url = await uploadImage(image);
            //register user
            registerUser({
                firstName,
                lastName,
                email,
                picture: url,
                password,
            }).then(({ data }) => {
                if (data) {
                    navigate('/chat')
                }
            });
        }
    };

    return (
        <Row>
            {" "}
            <Col className="register_bg"></Col>
            <Col
                md={6}
                className="d-flex flex-direction-colum align-items-center justify-content-center"
            >
                <div>
                    <Form onSubmit={registerNewUser} style={{ width: '350px'}} >
                        <div className="register-profileImage-container">
                            <img
                                src={imagePreview || profileHolder}
                                alt="holderimage"
                                className="register-profileImage"
                            />
                            <label
                                htmlFor="uploadProfileImage"
                                className="addProfileImage"
                            >
                                <i
                                    className="fa fa-plus"
                                    aria-hidden="true"
                                ></i>
                            </label>
                            <input
                                type="file"
                                hidden
                                name="picture"
                                id="uploadProfileImage"
                                accept="image.png, image/jpg, image/jpeg"
                                onChange={validateImage}
                            />
                        </div>
                        <Form.Group
                            className="mb-3"
                            controlId="formBasicFirstName"
                        >
                            <Form.Label>First Name</Form.Label>
                            <Form.Control
                                onChange={onChange}
                                type="text"
                                placeholder="Enter first name"
                                name="firstName"
                                value={firstName}
                            />
                        </Form.Group>
                        <Form.Group
                            className="mb-3"
                            controlId="formBasicLastName"
                        >
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control
                                onChange={onChange}
                                type="text"
                                placeholder="Enter last name"
                                name="lastName"
                                value={lastName}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Email address</Form.Label>
                            <Form.Control
                                onChange={onChange}
                                type="email"
                                placeholder="Enter email"
                                name="email"
                                value={email}
                            />
                            <Form.Text className="text-muted">
                                We'll never share your email with anyone else.
                            </Form.Text>
                        </Form.Group>

                        <Form.Group
                            className="mb-3"
                            controlId="formBasicPassword"
                        >
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                onChange={onChange}
                                type="password"
                                placeholder="Password"
                                name="password"
                                value={password}
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit">
                            {uploadingImage
                                ? "registering user ..."
                                : "register"}
                        </Button>
                        <div>
                            Already have an account?{" "}
                            <Link to="/login">Login</Link>
                        </div>
                    </Form>
                </div>
            </Col>
        </Row>
    );
};

export default Register;
